<template>
  <section class="code-confirm-pop-up">
    <el-row style="padding: 40px 20px 10px 20px" type="flex" justify="center">
      <h3 style="padding: 0 5px 10px 0">Підтвердження номера телефону</h3>
      <i class="el-icon-phone"></i>
      <el-col :span="12">
        <el-input
          type="text"
          maxlength="6"
          v-model="code"
          placeholder="Ваш код з sms"
        >
        </el-input>
        <el-button
          style="display: flex; margin: 10px auto"
          type="primary"
          round
          :disabled="code.length < 6"
          icon="el-icon-check"
          size="mini"
          @click="verifyPhone"
          :loading="loading"
          >Відправити
        </el-button>
        <!--        <el-button-->
        <!--          @click="resendCode"-->
        <!--          style="display: flex; margin: 0 auto"-->
        <!--          type="text"-->
        <!--          >Надіслати код повторно <span id="counter-code"></span-->
        <!--        ></el-button>-->
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { countdown } from '@/helper'

export default {
  name: 'CodeConfirmPopUp',
  data() {
    return {
      code: '',
      loading: false,
    }
  },
  methods: {
    async verifyPhone() {
      try {
        this.loading = true
        await this.$store.dispatch('verifyPhone', { code: this.code })
        this.$emit('close')
        this.$successMessage('Ваш телефон підтверджено')
      } catch (e) {
        this.$errorMessage('Перевірте правильність введенного коду')
      } finally {
        this.loading = false
      }
    },
    resendCode() {
      countdown(1)
    },
  },
}
</script>

<style scoped></style>
